export const fields = [
  { id: 'migration', label: 'Migração da dor para a fossa ilíaca direita', group: 'Sintomas' },
  { id: 'anorexia', label: 'Anorexia (perda de apetite)', group: 'Sintomas' },
  { id: 'nausea', label: 'Náuseas ou vômitos', group: 'Sintomas' },
  { id: 'vomiting', label: 'Vômitos', group: 'Sintomas' },
  { id: 'tenderness', label: 'Dor à palpação na fossa ilíaca direita', group: 'Exame físico' },
  { id: 'rightPain', label: 'Dor na fossa ilíaca direita', group: 'Exame físico' },
  { id: 'rebound', label: 'Descompressão brusca dolorosa', group: 'Exame físico' },
  { id: 'coughPain', label: 'Dor à tosse, percussão ou saltitar na fossa ilíaca direita', group: 'Exame físico' },
  { id: 'fever', label: 'Febre (avaliação clínica, PAS)', group: 'Exame físico' },
  { id: 'temperature', label: 'Temperatura (°C)', group: 'Medidas', type: 'number', step: '0.1', min: 30, max: 45 },
  { id: 'leukocytes', label: 'Leucócitos (/mm³)', group: 'Medidas', type: 'number', step: '1', min: 0, max: 100000 },
  { id: 'neutrophils', label: 'Neutrófilos (%)', group: 'Medidas', type: 'number', step: '0.1', min: 0, max: 100 },
  { id: 'neutrophilia', label: 'Neutrofilia (PAS, conforme referência laboratorial)', group: 'Medidas' },
  { id: 'crp', label: 'PCR (mg/L)', group: 'Medidas', type: 'number', step: '0.1', min: 0, max: 1000 },
  { id: 'reboundGrade', label: 'Intensidade da descompressão brusca (AIR)', group: 'Exame físico', type: 'select' }
];

export const scores = [
  {
    id: 'alvarado', name: 'Alvarado', subtitle: 'MANTRELS · 0–10 pontos', origin: 'Alvarado, 1986',
    audience: 'Adultos; exige hemograma, não exige PCR.',
    items: ['Migração da dor 1', 'Anorexia 1', 'Náuseas ou vômitos 1', 'Dor à palpação em FID 2', 'Descompressão dolorosa 1', 'Temperatura > 37,3 °C 1', 'Leucócitos > 10.000/mm³ 2', 'Neutrófilos > 75% 1'],
    usage: 'Reúna história, exame físico, temperatura e hemograma; marque os achados presentes; some os pontos e interprete a faixa.',
    application: 'Organiza achados na avaliação inicial de suspeita de apendicite.',
    interpretation: '0–4: baixa probabilidade; 5–6: intermediária; 7–8: provável; 9–10: muito provável.',
    required: ['migration', 'anorexia', 'nausea', 'tenderness', 'rebound', 'temperature', 'leukocytes', 'neutrophils'],
    max: 10
  },
  {
    id: 'modified', name: 'Alvarado modificado', subtitle: 'Sem desvio à esquerda · 0–9 pontos', origin: 'Adaptação do escore de Alvarado, 1986',
    audience: 'Adultos quando não há diferencial de neutrófilos; exige contagem de leucócitos, não exige PCR.',
    items: ['Migração da dor 1', 'Anorexia 1', 'Náuseas ou vômitos 1', 'Dor à palpação em FID 2', 'Descompressão dolorosa 1', 'Temperatura > 37,3 °C 1', 'Leucócitos > 10.000/mm³ 2'],
    usage: 'Registre os sete critérios clínicos e laboratoriais; some os pontos sem incluir o desvio à esquerda; compare com o corte.',
    application: 'Alternativa simplificada quando o diferencial de neutrófilos não está disponível.',
    interpretation: '7 ou mais pontos sugerem apendicite; abaixo de 7 não a exclui.',
    required: ['migration', 'anorexia', 'nausea', 'tenderness', 'rebound', 'temperature', 'leukocytes'],
    max: 9
  },
  {
    id: 'pas', name: 'PAS', subtitle: 'Pediatric Appendicitis Score · 0–10 pontos', origin: 'Samuel, 2002',
    audience: 'Crianças; exige hemograma, não exige PCR.',
    items: ['Dor à tosse, percussão ou saltitar em FID 2', 'Anorexia 1', 'Febre 1', 'Náuseas ou vômitos 1', 'Dor à palpação em FID 2', 'Leucócitos > 10.000/mm³ 1', 'Neutrofilia 1', 'Migração da dor 1'],
    usage: 'Avalie sintomas e exame físico da criança; confira o hemograma; some cada item presente e contextualize o resultado.',
    application: 'Estrutura a avaliação pediátrica de dor abdominal com suspeita de apendicite.',
    interpretation: '7 ou mais pontos sugerem apendicite; resultado menor não exclui a doença.',
    required: ['coughPain', 'anorexia', 'fever', 'nausea', 'tenderness', 'leukocytes', 'neutrophilia', 'migration'],
    max: 10
  },
  {
    id: 'air', name: 'AIR', subtitle: 'Appendicitis Inflammatory Response · 0–12 pontos', origin: 'Andersson e Andersson, 2008',
    audience: 'Adultos com hemograma diferencial e PCR disponíveis.',
    items: ['Vômitos 1', 'Dor em FID 1', 'Descompressão leve 1 / moderada 2 / forte 3', 'Temperatura ≥ 38,5 °C 1', 'Neutrófilos 70–84% 1 / ≥ 85% 2', 'Leucócitos 10.000–14.900 1 / ≥ 15.000 2', 'PCR 10–49 mg/L 1 / ≥ 50 mg/L 2'],
    usage: 'Reúna sintomas, exame físico, temperatura, hemograma diferencial e PCR; atribua a faixa correta em cada medida e some.',
    application: 'Combina inflamação laboratorial e achados clínicos na estratificação de risco.',
    interpretation: '0–4: baixo risco; 5–8: indeterminado; 9–12: alto risco.',
    required: ['vomiting', 'rightPain', 'reboundGrade', 'temperature', 'neutrophils', 'leukocytes', 'crp'],
    max: 12
  }
];

export function calculate(id, v) {
  const yes = key => v[key] === true ? 1 : 0;
  const n = key => v[key] === '' || v[key] == null ? NaN : Number(v[key]);
  const leuk = n('leukocytes');
  const neut = n('neutrophils');
  const temp = n('temperature');
  const common = yes('migration') + yes('anorexia') + yes('nausea') + 2 * yes('tenderness') + yes('rebound') + (temp > 37.3 ? 1 : 0) + (leuk > 10000 ? 2 : 0);
  if (id === 'alvarado') return common + (neut > 75 ? 1 : 0);
  if (id === 'modified') return common;
  if (id === 'pas') return 2 * yes('coughPain') + yes('anorexia') + yes('fever') + yes('nausea') + 2 * yes('tenderness') + (leuk > 10000 ? 1 : 0) + yes('neutrophilia') + yes('migration');
  const grade = Number(v.reboundGrade || 0);
  return yes('vomiting') + yes('rightPain') + grade + (temp >= 38.5 ? 1 : 0) + (neut >= 85 ? 2 : neut >= 70 ? 1 : 0) + (leuk >= 15000 ? 2 : leuk >= 10000 ? 1 : 0) + (n('crp') >= 50 ? 2 : n('crp') >= 10 ? 1 : 0);
}

export function interpret(id, value) {
  if (id === 'alvarado') return value <= 4 ? 'Baixa probabilidade' : value <= 6 ? 'Probabilidade intermediária' : value <= 8 ? 'Provável' : 'Muito provável';
  if (id === 'air') return value <= 4 ? 'Baixo risco' : value <= 8 ? 'Indeterminado' : 'Alto risco';
  return value >= 7 ? 'Sugere apendicite' : 'Abaixo do ponto de corte; não exclui apendicite';
}
